import accesSouscriptionAbonnementApi from '@/api/abonnement/acces-souscription-abonnement.api'

const module = {
  namespaced: true,

  actions: {
    incrementerAccesSouscriptionAbonnement ({ rootGetters }, fonctionnalite) {
      const typesUser = rootGetters['user/profil'].userTypes

      if (typesUser.includes('TIERS_ADHERENT') || typesUser.includes('TIERS_NON_ADHERENT')) {
        const numtiers = rootGetters['user/profil'].username
        return accesSouscriptionAbonnementApi.incrementerAccesSouscriptionAbonnement(numtiers, fonctionnalite)
      }
    },
  }
}

export default module
